var _excluded = ["value", "onChange", "onClick", "placeholder", "heightSpace", "hasError", "hasSuccess", "errorMessage", "typography", "backgroundColor", "maxLength"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useState } from "react";
import { rgba } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import { lowEmphasisOpacity } from "../../../settings";
import getColor from "../../../utils/getColor";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import TextAtm from "../../atoms/TextAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import PushOrg from "../../organisms/PushOrg";
import Placeholder from "../InputMol/Components/Placeholder";
import { InputWrapper, PlaceholderWrapper, inputBaseStylesWithHover } from "../InputMol/InputMol.styled";
export var defaultProps = {
  heightSpace: 15
};
var StyledTextareaMol = styled.textarea.withConfig({
  componentId: "sc-vw14db-0"
})(function (_ref) {
  var $hasHover = _ref.$hasHover,
    $hasFocus = _ref.$hasFocus,
    $onColor = _ref.$onColor,
    $hasError = _ref.$hasError,
    $hasSuccess = _ref.$hasSuccess,
    $hasPlaceholder = _ref.$hasPlaceholder,
    $hasValue = _ref.$hasValue,
    $typography = _ref.$typography,
    $backgroundColor = _ref.$backgroundColor,
    theme = _ref.theme;
  return css(["", ";height:auto;background-color:", ";padding:", " ", ";resize:none;", " ", " ", " ", ""], inputBaseStylesWithHover($hasHover, $hasFocus, $onColor, "default"), $backgroundColor ? getColor(theme, $backgroundColor) : null, space(2.5), space(2), $hasError && !$hasFocus && css(["border-color:", ";"], rgba(getColor(theme, "error"), lowEmphasisOpacity)), $hasSuccess && $hasFocus && css(["border-color:", ";"], rgba(getColor(theme, "success"), lowEmphasisOpacity)), $hasPlaceholder && $hasValue && css(["padding-top:", ";padding-bottom:", ";"], space(4), space(1)), isNotEmpty($typography) ? css(["", ";"], cssTextAtm({
    typography: $typography,
    onColor: $onColor
  })) : null);
});
function TextareaMol(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    onClick = _ref2.onClick,
    placeholder = _ref2.placeholder,
    _ref2$heightSpace = _ref2.heightSpace,
    heightSpace = _ref2$heightSpace === void 0 ? defaultProps.heightSpace : _ref2$heightSpace,
    hasError = _ref2.hasError,
    hasSuccess = _ref2.hasSuccess,
    errorMessage = _ref2.errorMessage,
    typography = _ref2.typography,
    backgroundColor = _ref2.backgroundColor,
    maxLength = _ref2.maxLength,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var handleOnMouseEnter = function handleOnMouseEnter() {
    setHover(true);
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    setHover(false);
  };
  var handleOnFocus = function handleOnFocus() {
    setFocus(true);
  };
  var handleOnBlur = function handleOnBlur() {
    setFocus(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputWrapper, null, placeholder ? /*#__PURE__*/React.createElement(PlaceholderWrapper, {
    $size: "default",
    $hasValue: !!value
  }, /*#__PURE__*/React.createElement(Placeholder, {
    placeholder: placeholder,
    hasValue: !!value,
    hasError: hasError,
    hasSuccess: hasSuccess
  })) : null, /*#__PURE__*/React.createElement(StyledTextareaMol, _extends({
    value: value,
    placeholder: placeholder,
    rows: heightSpace,
    onChange: onChange,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onClick: onClick,
    maxLength: maxLength,
    $hasError: !!hasError,
    $hasSuccess: !!hasSuccess,
    $hasHover: hover,
    $hasFocus: focus,
    $hasPlaceholder: !!placeholder,
    $hasValue: !!value,
    $onColor: onColor,
    $typography: typography,
    $backgroundColor: backgroundColor
  }, restProps))), errorMessage && hasError ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    color: "error"
  }, errorMessage)) : null);
}
export default TextareaMol;